/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_MyGroupPresenceSegment = {
    /**
     * null while the caller is in the group
     */
    ended_at: string | null;
    /**
     * Who closed the span: the caller (employee, switch), the automatic close at shift
     * end or day end (shift_end, day_end), or the organisation switch (admin). null while open.
     */
    ended_reason: employee_selfservice_MyGroupPresenceSegment.ended_reason | null;
    group_id: string;
    group_name: string;
    id: string;
    started_at: string;
};
export namespace employee_selfservice_MyGroupPresenceSegment {
    /**
     * Who closed the span: the caller (employee, switch), the automatic close at shift
     * end or day end (shift_end, day_end), or the organisation switch (admin). null while open.
     */
    export enum ended_reason {
        EMPLOYEE = 'employee',
        SWITCH = 'switch',
        SHIFT_END = 'shift_end',
        DAY_END = 'day_end',
        ADMIN = 'admin',
    }
}

